export const PWA_INSTALL_COACHMARK_COOKIE = 'orgcloud_pwa_install_coachmark';
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 400;

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(value: string): void {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${PWA_INSTALL_COACHMARK_COOKIE}=${encodeURIComponent(
    value
  )}; Path=/; Max-Age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax${secure}`;
}

export function getPwaInstallCoachmarkState(): 'hidden' | 'installed' | null {
  const value = readCookie(PWA_INSTALL_COACHMARK_COOKIE);
  if (value === 'hidden' || value === 'installed') return value;
  return null;
}

export function hidePwaInstallCoachmark(): void {
  writeCookie('hidden');
}

export function markPwaInstalled(): void {
  writeCookie('installed');
}

